"use client"

import { usePathname } from "next/navigation"
import { Navbar } from "./Navbar"
import { Footer } from "./Footer"
import { cn } from "@/lib/utils"

interface SiteShellProps {
    children: React.ReactNode
}

export function SiteShell({ children }: SiteShellProps) {
    const pathname = usePathname()

    // Check if the current route is an admin route
    const isAdminRoute = pathname?.startsWith("/admin")

    // If it's an admin route, we only return children without the main site's Navbar/Footer
    if (isAdminRoute) {
        return <>{children}</>
    }

    // Standard site shell for all other routes
    const isHomePage = pathname === "/"
    const isDashboardRoute = pathname?.startsWith("/dashboard")

    return (
        <div className="relative min-h-screen flex flex-col bg-slate-950 text-slate-100 overflow-x-hidden">
            {/* Background for public section */}
            {!isDashboardRoute && (
                <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
                    <div
                        className="absolute inset-0 bg-[url('/images/dark_dragon_banner.jpg')] bg-cover bg-right md:bg-right-top bg-no-repeat opacity-45 transition-opacity duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-slate-950/40 via-slate-950/70 to-slate-950/95" />
                    <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-950/50 to-transparent" />
                </div>
            )}

            {/* Background for user panel / dashboard section */}
            {isDashboardRoute && (
                <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
                    <div
                        className="absolute inset-0 bg-[url('/images/user_panel_bg.jpg')] bg-cover bg-center bg-no-repeat opacity-35 transition-opacity duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-slate-950/65 via-slate-950/85 to-slate-950/95" />
                </div>
            )}

            <Navbar />
            <main className={cn("relative z-10 flex-1", !isHomePage && "pt-24 md:pt-32")}>
                {children}
            </main>
            <Footer />
        </div>
    )
}

